import { FunctionComponent, useEffect, useRef, useState } from "react";
import Table from "../Table";
import "./styles.scss";
import { Icon } from "../Icon";
import { ProductServices } from "../../services/products";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import classNames from "classnames";

type Props = {
  lengths: string[];
  table: string[][];
  product: Product;
  closeModal: () => void;
};

const TableModal: FunctionComponent<Props> = ({
  lengths,
  table,
  closeModal,
  product,
}) => {
  const tableContainer = useRef<null | HTMLDivElement>(null);

  const modalContent = useRef<null | HTMLDivElement>(null);
  const [higher, setHigher] = useState<boolean>(false);
  const labels: LenghtLabel = ProductServices.getProductsLabels(
    product.category,
    product.department,
    product.isCustom
  );
  useEffect(() => {
    tableContainer.current && disableBodyScroll(tableContainer.current);
    modalContent.current &&
    modalContent.current?.offsetHeight > window.innerHeight
      ? setHigher(true)
      : setHigher(false);
  }, []);
  return (
    <section
      className={classNames(
        "table_modal_container",
        higher ? "table_modal_container__block" : null
      )}
      ref={tableContainer}
    >
      <button onClick={closeModal} className="table_modal_button">
        <Icon iconName="close_x_icon" />
      </button>
      <div ref={modalContent}>
        <Table
          lengths={lengths}
          table={table}
          vertical={labels.gaugeLabel}
          horizontal={labels.lenghtLabel}
          unit={labels.unit}
        />
      </div>
    </section>
  );
};

export default TableModal;
